import { useDeleteEntityApi } from "@/common/api/deleteEntityApi";
import { useInboundDeliveryStore } from "../stores/inboundDeliveryStore";

export function useDeleteInboundDeliveryApi() {

  const store = useInboundDeliveryStore();

  return useDeleteEntityApi({
    url: 'delivery/inbound',
    translate: (t) => t.inboundDelivery.actions.delete,
    async processOk(request) {
      store.remove(request.id);
      return Promise.resolve({
        ok: true
      });
    },
  })
}
